<div class="bp-modal mod-lg wrapper">
	<bp-modal-header [title]="'address_book_deposit_on_hold' | translate">
		<button class="cancel-button" left (click)="back()" (keydown.enter)="back()" [tabIndex]="0">
			@if(!hasWalletHost) {
			<strong>{{ "back" | translate }}</strong>
			}
		</button>
		<button class="cancel-button" right (click)="cancel()" (keydown.enter)="cancel()" [tabIndex]="0">
			@if(!hasWalletHost) {
			<strong>{{ "cancel" | translate }}</strong>
			}
		</button>
	</bp-modal-header>

	<div class="bp-modal-body">
		<div class="bp-modal-description">
			<div class="header">
				<h2>
					@if(!hasWalletHost) {
					{{ "address_book_sender_information" | translate }}
					} @else {
					{{ "address_book_processing_information" | translate }}
					}
				</h2>
				<span class="title-description">
					@if(!hasWalletHost) {
					{{ "address_book_additional_information" | translate }}
					} @else {
					{{ "address_book_confirmation_of_verification" | translate }}
					}
				</span>
			</div>
		</div>
		<div class="bp-modal-body-section">
			<form [formGroup]="newWalletForm">
				<div class="inputs pb-15">
					@if (!hasWalletHost) {
					<label
						class="form-label"
						[ngClass]="{ 'text-red': newWalletForm.controls.walletOwner.errors?.invalid_owner_name }"
						for="walletOwner">
						{{ "wallet_owner" | translate }}
					</label>
					<input
						type="text"
						id="walletOwner"
						class="form-field mb-10"
						[ngClass]="{
							'mb-5 error-border': newWalletForm.controls.walletOwner.errors?.invalid_owner_name
						}"
						formControlName="walletOwner"
						[placeholder]="'complete_name' | translate" />
					@if(newWalletForm.controls.walletOwner.errors?.invalid_owner_name) {
					<span class="bpi__icon-close-round text-red font-size-11"> {{ walletOwnerError }}</span>
					}
					@if(this.modeSelection === onHoldWalletSelection.EXCHANGE) {
					<bp-switch
						formControlName="ownWallet"
						ngDefaultControl
						(valueChange)="onOwnWalletChange($event)"
						field="ownWallet">
						<span left>{{ "the_wallet_belongs_to_me" | translate }}</span>
					</bp-switch>
					<bp-select
						(selectedValueChange)="onWalletHostChange($event)"
						[label]="'wallet_host' | translate"
						[useEmptyState]="true"
						[searchable]="true"
						[selectedValue]="newWalletForm.controls.walletHost.value"
						[customSearchFn]="getHostSearch()"
						[options]="walletHosts$ | async"
						formControlName="walletHost"
						[placeholder]="'choose_a_host' | translate"
						ngDefaultControl
						class="full-border host-input">
					</bp-select>
					@if(newWalletForm.controls.walletHost?.value === "other"){
					<div class="column">
						<label
							class="form-label mt-25"
							[ngClass]="{ 'text-red': newWalletForm.controls.otherHostName.errors?.invalid_host_hint }"
							for="otherHostName">
							{{ "host_name" | translate }}
						</label>
						<input
							type="text"
							id="otherHostName"
							class="form-field"
							[ngClass]="{
								'mb-5   error-border': newWalletForm.controls.otherHostName.errors?.invalid_host_hint
							}"
							formControlName="otherHostName"
							[placeholder]="'host_name' | translate" />
						@if(newWalletForm.controls.otherHostName.errors?.invalid_host_hint) {
						<span class="bpi__icon-close-round text-red font-size-11"> {{ hostHintError }}</span>
						}
					</div>
					}	
					}
					}
					<div class="details-container">
						<div class="details-item">
							<span class="label">{{ "wallet_addresses" | translate }}:</span>
							<span>{{ transactionData?.payment_data?.wallet_address }}</span>
						</div>
						<div class="details-item">
							<span class="label">{{ "address_book_deposit_amount" | translate }}:</span>
							<span>{{ transactionData?.asset_amount }} {{ transactionData?.asset_symbol }}</span>
						</div>
						<div class="details-item">
							<span class="label">{{ "date_tx_item" | translate }}:</span>
							<span>
								{{
									transactionData?.created_at
										| bp_date
											: {
													hours: "HH",
													minutes: "mm",
													seconds: false,
													timeSeperator: ":"
											  }
								}}
							</span>
						</div>
					</div>
					@if (shouldShowSelfDeclaration && !hasWalletHost) {
					<bp-switch
						formControlName="selfDeclared"
						class="self-declared"
						ngDefaultControl
						(valueChange)="onSelfDeclaredChange($event)"
						field="selfDeclared">
						<span left>{{ "self_declare" | translate }}</span>
					</bp-switch>
					}
					@if (isSHWMode && !hasWalletHost) {
					<div class="warning-container mt-25 padding-15">
						<p class="warning-title">{{ "wallet_may_require_validation_title" | translate }}</p>
						<p class="warning-description mb-15">
							{{ "address_book_self_hosted_warning_message" | translate }}
						</p>
						<a class="learn-more" [href]="learnMoreUrl" target="_blank">
							{{ "more_information" | translate }}
						</a>
					</div>
					}
				</div>
				<button
					[disabled]="
						!hasWalletHost && (newWalletForm.invalid || (!SHW3rdPartyDisabled && !newWalletForm.controls.selfDeclared.value))
					"
					(click)="!hasWalletHost ? updateWallet() : cancel()"
					type="submit"
					class="btn btn-primary save-wallet-btn">
					@if(!hasWalletHost) {
					{{ "address_book_next" | translate }}
					}@else {
					{{ "ok" | translate }}
					}
				</button>
			</form>
		</div>
	</div>
</div>
